import apiClient from './apiClient';

export const payoutService = {
  // Get all withdrawal requests
  getAllPayouts: () => {
    return apiClient.get('/admin/payouts');
  },

  // Approve a payout request
  approvePayout: (payoutId) => {
    return apiClient.post(`/admin/payouts/${payoutId}/approve`);
  },

  // Reject a payout request
  rejectPayout: (payoutId) => {
    return apiClient.post(`/admin/payouts/${payoutId}/reject`);
  },
};